// extracted by mini-css-extract-plugin
export var classNameInput = "messages-module--class-name-Input--a38cd";
export var emptyWrapper = "messages-module--empty-wrapper--a2755";
export var messenger = "messages-module--messenger--6229d";
export var searchBar = "messages-module--search-bar--bbedd";
export var wrapper = "messages-module--wrapper--9e048";